<script>
export default {
    name: "CancelBillForm",

    props: {
        patient: Object,
        billItem: Object,
        showModal: Boolean,
    },

    computed: {
        canceBill() {

            return {
                invoiceDetailID: this.billItem.invoiceDetailID,
                visitNo: this.patient.visitNo,
                userName: this.$root.username,
                patientName: this.patient.names
            };
        },
    },

    methods: {

        saveCancelBill() {
            this.$root.loading = true;
            this.$http.post(`Accounts/CancelPatientBillItem`, this.canceBill).then(response => {
                this.$emit('refresh');
                this.$root.loading = false;
                this.$emit('closeModal');
                window.Swal.fire({ type: `success`, text: response.data, });
            }).catch(() => {
                this.$root.loading = false;
                this.$emit('closeModal');
            });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/4 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-base">Cancel Bill</h5>
      </template>
      <template v-slot:modal-body>
        <div class="-m-4">
            <h5 class="font-bold text-red-600 text-base text-center">Confirm Cancel Bill!</h5>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-6" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Close</button>
        <button class="btn-primary btn-sm text-xs" @click.prevent="saveCancelBill"><i class="fa fa-ban"></i> Cancel Bill</button>
      </template>
    </tail-modal>
</template>